import React,{useContext,useEffect, useState, useRef, useMemo, useCallback} from 'react';
import { DatabaseContext } from '../../redux/DatabaseStore';
import { useFormik } from 'formik';
import { deleteRequest, getRequest, postRequest } from '../../api/ApiController';
import { confirmDialog } from 'primereact/confirmdialog';
import { SaveIcon, AddIcon, EditIcon, CopyIcon, DeleteIcon, StepBackIcon, StepForwardIcon, PrintIcon, SearchIcon, ExportIcon, VerticalLineIcon, BackToFirstIcon, BackIcon, ForwardIcon, ForwardToLastIcon, FavoriteIcon, PriceIcon, SaveAndCloseIcon} from "../svg/svgIcons";
import { Dialog } from 'primereact/dialog';
import { InfinitySpin } from  'react-loader-spinner';
import AuthContext from '../../components/AuthContext';
import UtilContext from '../../components/UtilContext';
import { LocaleContext } from '../../components/LocaleContext';
import { createArrayNavigateHandlers } from '../../utils/arrayNavigate';

export default function EmployeeAdd({employee,type}) {
    const isCopyMode = type === 'copy';
    const copiedUserPreferredLanguage = ['sk', 'en', 'de'].includes(String(employee?.user?.preferred_language ?? '').trim().toLowerCase())
        ? String(employee?.user?.preferred_language ?? '').trim().toLowerCase()
        : '';
    const normalizeDateInput = (value) => {
        if (!value) return '';
        const str = String(value);
        return str.length >= 10 ? str.slice(0, 10) : str;
    };
    const sanitizeEmployeeForCopy = (source) => ({
        ...(source || {}),
        id: '',
        user: null,
        contractor_id: null,
        last_touched_by_user_id: null,
        created_at: null,
        updated_at: null,
    });

    const [state,dispatch] = useContext(DatabaseContext);
    const {user} = useContext(AuthContext);
    const {openFavoriteDialog,toast,setFastView,setVisible,setDialogText}= useContext(UtilContext);
    const { t } = useContext(LocaleContext);

    const [formEmployee,setFormEmployee] = useState(isCopyMode ? sanitizeEmployeeForCopy(employee) : employee);
    const [formUser,setFormUser] = useState(isCopyMode ? sanitizeEmployeeForCopy(employee) : employee);
    const [employeeType, setEmployeeType] = useState(isCopyMode ? 'add' : type);
    const [employeeAccount, setEmployeeAccount] = useState(isCopyMode ? false : (employee!=null && employee?.user!==null && employee?.user?.username!==null && state.employees.filter(employee => employee.id===employee?.id && employee?.id!==null)[0]?.user?.username!==null));
    const [accountEmail,setAccountEmail] = useState(isCopyMode ? null : employee?.email);
    const defaultCompanyLanguage = useMemo(() => {
        const lang = String(state?.company_settings_print?.preferred_language ?? '').trim().toLowerCase();
        return ['sk', 'en', 'de'].includes(lang) ? lang : 'sk';
    }, [state?.company_settings_print?.preferred_language]);
    const [accountPreferredLanguage, setAccountPreferredLanguage] = useState(defaultCompanyLanguage);

    const [insertCopyIcon,setInsertCopyIcon] = useState(!user.permissions?.includes("add users"));
    const [stepBackIcon,setStepBackIcon] = useState(true);
    const [scrollIcons,setScrollIcons] = useState(true);
    const [closeTab,setCloseTab] = useState(false);

    const submitRef = useRef(null);
    const componentRef = useRef(null);

    useEffect(() => {
        // Update the document title using the browser API
        if(employeeType=="edit"){
            setScrollIcons(false);
        }
    },[employeeType]);

    useEffect(() => {
        if (isCopyMode) {
            setEmployeeAccount(false);
            return;
        }
        // Update the document title using the browser API
        //console.log(formEmployee);
        setEmployeeAccount((formEmployee?.user!==null && formEmployee?.user?.username!==null && state.employees.filter(employee => employee.id===formEmployee?.id && formEmployee?.id!==null)[0]?.user?.username!==null));
        if(!employeeAccount){
            let name = formEmployee?.name.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
            let split_name = name?.split(" ");
            if(split_name?.length > 1){
                userformik.setFieldValue("username",split_name[split_name.length-1][0]+split_name[split_name.length-2]);
            }
        }
    },[employeeAccount, formEmployee, isCopyMode, state.employees]);

    useEffect(() => {
        const lang = String(formEmployee?.user?.preferred_language ?? '').trim().toLowerCase();
        setAccountPreferredLanguage(['sk', 'en', 'de'].includes(lang) ? lang : defaultCompanyLanguage);
    }, [defaultCompanyLanguage, formEmployee?.user?.preferred_language]);

    function isValidEmail(email) {
        return /\S+@\S+\.\S+/.test(email);
      }

    const validate = useCallback((values) => {
        const errors = {};
        if (!values.name) {
            errors.name = t('Common.RequiredField');
        }
        if (!values.defined_id) {
            errors.defined_id = t('Common.RequiredField');
        }
        if (!values.department_id) {
            errors.department_id = t('Common.RequiredField');
        }
        if (values.email && values.email !== '') {
            if (!isValidEmail(values.email)) {
                errors.email = t('EmployeeAdd.Error.InvalidEmail');
            }
        }
        return errors;
    }, [t, employeeType, formEmployee, state.employees]);

    /* form for adding error record */
    const formik = useFormik({
        initialValues: formEmployee==null?{
            id: '',name:'',description:'',defined_id:'',date_of_entry:'',date_of_departure:'',
            email:'',tel_number:'',state:'OK',department_id:''
        }:{
            ...formEmployee,
            date_of_entry: normalizeDateInput(formEmployee?.date_of_entry),
            date_of_departure: normalizeDateInput(formEmployee?.date_of_departure),
        },
        enableReinitialize:true,
        validate,
        onSubmit: values => {
            let formData = new FormData();
            for (let value in values) {
                formData.append(value, values[value] != null ? values[value] : "");
            }
            setDialogText(t('Common.Saving'));
            setVisible(true);
            if(employeeType==="add"){
                postRequest('/api/employees', formData,true)
                .then((response) => {
                    getRequest("/api/employees").then((response) => {
                        dispatch({type:'load_employees',newEmployees:response.data});
                        if(closeTab)dispatch({type:'close_tab',id:state.selectedTab});
                        if(response.data.length-1>=0)formik.setValues(response.data[response.data.length-1]);
                        setAccountEmail(response.data[response.data.length-1]?.email)
                        setEmployeeType("edit");
                        setVisible(false);
                        toast?.current?.show({ severity: 'info', summary: t('DepartmentList.Toast.DeletedSummary'), life: 3000, detail: t('Common.Toast.RecordSavedDetail') });
                    });
                }).catch((reason) => {
                    setVisible(false);
                    alert(t('Common.Toast.ActionFailedDetail'));
                })
            }
            else{
                postRequest(`/api/employees/update/${formik.values.id}`, formData,true)
                .then((response) => {
                    getRequest("/api/employees").then((response) => {
                        dispatch({type:'load_employees',newEmployees:response.data});
                        if(closeTab)dispatch({type:'close_tab',id:state.selectedTab});
                        formik.setValues(values);
                        setAccountEmail(values?.email);
                        if(!employeeAccount){
                            let name = values?.name.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
                            let split_name = name.split(" ");
                            if(split_name.length > 1){
                                userformik.setFieldValue("username",split_name[split_name.length-1][0]+split_name[split_name.length-2]);
                            }
                        }
                        setVisible(false);
                        toast?.current?.show({ severity: 'info', summary: t('DepartmentList.Toast.DeletedSummary'), life: 3000, detail: t('Common.Toast.RecordUpdatedDetail') });
                    });
                }).catch((reason) => {
                    setVisible(false);
                    alert(t('Common.Toast.ActionFailedDetail'));
                })
            }
        },
    });

    const userFormikValidate = useCallback((values) => {
        const errors = {};
        if (!values.username) {
            errors.username = t('Common.RequiredField');
        } else if (!accountEmail || accountEmail === '') {
            errors.username = t('EmployeeAdd.Error.NoEmployeeEmail');
        } else if (String(values.username).length < 5) {
            errors.username = t('EmployeeAdd.Error.UsernameShort');
        }
        if (values.role === '' || values.role == null) {
            errors.role = t('Common.RequiredField');
        }
        return errors;
    }, [t, accountEmail]);

    function setUsernameForNotRegisterUser(){
        let name = formEmployee?.name.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
        if(name){
            let split_name = name?.split(" ");
            if(split_name?.length > 1){
                console.log(split_name[split_name.length-1][0]+split_name[split_name.length-2]);
                return split_name[split_name.length-1][0]+split_name[split_name.length-2];
            }
        }
        return "";
    }

    const userformik = useFormik({
        initialValues: {
            username:isCopyMode ? '' : (formEmployee?.user?.username || setUsernameForNotRegisterUser()),
            role:isCopyMode ? '' : (formEmployee?.user?.role || ''),
            preferred_language: isCopyMode
                ? (copiedUserPreferredLanguage || defaultCompanyLanguage)
                : (['sk', 'en', 'de'].includes(String(formEmployee?.user?.preferred_language ?? '').toLowerCase())
                ? String(formEmployee?.user?.preferred_language ?? '').toLowerCase()
                : defaultCompanyLanguage),
        },
        enableReinitialize:true,
        validate: userFormikValidate,
        onSubmit: values => {
            let formData2 = new FormData();
            for (let value in values) {
                formData2.append(value, values[value] != null ? values[value] : "");
            }
            formData2.append("employee_id",formEmployee.id);
            setDialogText(t('Common.Saving'));
            setVisible(true);
            postRequest('/api/users', formData2,true)
            .then((response) => {
                employee.user = response.data;
                employee.user.role = response.data.roles[0]?.name;
                setFormEmployee(employee);
                getRequest("/api/employees").then((response) => {
                    dispatch({type:'load_employees',newEmployees:response.data});
                    if(closeTab)dispatch({type:'close_tab',id:state.selectedTab});
                    setEmployeeAccount((employee?.user!==null && employee?.user?.username!==null && state.employees.filter(employee => employee.id===employee?.id && employee?.id!==null)[0]?.user?.username!==null));
                    setVisible(false);
                    toast?.current?.show({ severity: 'info', summary: t('DepartmentList.Toast.DeletedSummary'), life: 3000, detail: t('EmployeeAdd.Toast.InvitationSent')});
                });
            }).catch((reason) => {
                setVisible(false);
                alert(t('Common.Toast.ActionFailedDetail'));
            })
            
        },
    });

    const saveAssignedUserLanguage = useCallback(() => {
        if (!formEmployee?.user?.id) return;
        const roleFromStore = state.users.find((u) => String(u.id) === String(formEmployee.user.id))?.role;
        const role = formEmployee?.user?.role || roleFromStore || '';
        if (!role) {
            toast?.current?.show({ severity: 'warn', summary: t('DepartmentList.Toast.RejectedSummary'), detail: t('Common.Toast.ActionFailedDetail'), life: 3000 });
            return;
        }
        const formData = new FormData();
        formData.append('username', formEmployee?.user?.username ?? '');
        formData.append('role', role);
        formData.append('employee_id', formEmployee?.id ?? '');
        formData.append('preferred_language', accountPreferredLanguage || defaultCompanyLanguage);
        setDialogText(t('Common.Saving'));
        setVisible(true);
        postRequest(`/api/users/update/${formEmployee.user.id}`, formData, true)
            .then(() => {
                Promise.all([
                    getRequest('/api/employees'),
                    getRequest('/api/users'),
                ]).then(([employeesRes, usersRes]) => {
                    if (employeesRes?.data) dispatch({ type: 'load_employees', newEmployees: employeesRes.data });
                    if (usersRes?.data) dispatch({ type: 'load_users', newUsers: usersRes.data });
                    const updatedEmployee = employeesRes?.data?.find((e) => String(e.id) === String(formEmployee?.id));
                    if (updatedEmployee) setFormEmployee(updatedEmployee);
                    setVisible(false);
                    toast?.current?.show({ severity: 'info', summary: t('DepartmentList.Toast.DeletedSummary'), life: 3000, detail: t('Common.Toast.RecordUpdatedDetail') });
                });
            })
            .catch(() => {
                setVisible(false);
                alert(t('Common.Toast.ActionFailedDetail'));
            });
    }, [accountPreferredLanguage, defaultCompanyLanguage, dispatch, formEmployee, setDialogText, setVisible, state.users, t, toast]);

    function addNewEmployee(){
        dispatch({type:'create_new_tab',name: t('EmployeeList.Tab.New'), translationKey: 'EmployeeList.Tab.New', legacyLabel: t('EmployeeList.Tab.New'),page:'EmployeeAdd',props:{employee: null,type:'add'},mask:'gset004'})
    }

    function copyEmployee(){
        dispatch({type:'create_new_tab',name: t('EmployeeList.Tab.New'), translationKey: 'EmployeeList.Tab.New', legacyLabel: t('EmployeeList.Tab.New'),page:'EmployeeAdd',props:{employee: sanitizeEmployeeForCopy(formik.values),type:'copy'},mask:'gset004'})
    }

    const { scrollToFirst, scrollUp, scrollDown, scrollToLast } = useMemo(
        () => createArrayNavigateHandlers(state.employees, formik.values.id, setFormEmployee),
        [state.employees, formik.values.id]
    );

    const acceptReset = () => {
        postRequest(`/api/users/reset_password/${formEmployee.user.id}`, null,true)
        .then((response) => {
            toast?.current?.show({ severity: 'info', summary: t('DepartmentList.Toast.DeletedSummary'), life: 3000, detail: t('UserAdd.Toast.PasswordReset') });
        }).catch((reason) => {
            alert(t('Common.Toast.ActionFailedDetail'));
            toast?.current?.show({ severity: 'warn', summary: t('UserAdd.Toast.ResetRejectedSummary'), detail: t('UserAdd.Toast.ResetRejectedDetail'), life: 3000 });
        })
      }

      const acceptDelete = () => {
        deleteRequest(`/api/users/${formEmployee.user.id}`)
        .then((response) => {
            getRequest("/api/employees").then((response) => {
                setEmployeeAccount(0);
                dispatch({type:'load_employees',newEmployees:response.data});
                formEmployee.user = null;
                setFormEmployee(formEmployee);
                toast?.current?.show({ severity: 'info', summary: t('DepartmentList.Toast.DeletedSummary'), life: 3000, detail: t('ServiceTask.RecordDeleted') });
            });
        }).catch((reason) => {
            alert(reason);
            toast?.current?.show({ severity: 'warn', summary: t('DepartmentList.Toast.RejectedSummary'), detail: t('ServiceTask.RecordDeleteFailed'), life: 3000 });
        }) 
      }
    
      const rejectResetDelete = () => {
          toast?.current?.show({ severity: 'warn', summary: t('DepartmentList.Toast.RejectedSummary'), detail: t('ServiceTask.Toast.RequestCancelled'), life: 3000 });
      }
    
    const confirmReset = () => {
        confirmDialog({
            message: t('UserAdd.ConfirmReset.Message'),
            header: t('UserAdd.ConfirmReset.Header'),
            icon: 'pi pi-info-circle',
            rejectClassName: 'p-button-danger',
            acceptLabel: t('UserAdd.ConfirmReset.AcceptNo'),
            rejectLabel: t('UserAdd.ConfirmReset.RejectYes'),
            accept: rejectResetDelete,
            reject: acceptReset
        });
    };

    const confirmDelete = () => {
        confirmDialog({
            message: t('EmployeeAdd.ConfirmDeleteAccount.Message'),
            header: t('EmployeeAdd.ConfirmDeleteAccount.Header'),
            icon: 'pi pi-info-circle',
            rejectClassName: 'p-button-danger',
            acceptLabel: t('Common.No'),
            rejectLabel: t('Common.Yes'),
            accept: rejectResetDelete,
            reject: acceptDelete
        });
    };

    return (
        <div>
        <div className='w-full h-10 flex flex-row bg-[#333]'>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button type="submit" className="disabled:opacity-25" disabled={insertCopyIcon} onClick={() => {setCloseTab(true);submitRef.current.click();}}><SaveAndCloseIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button type="submit" className="disabled:opacity-25" disabled={insertCopyIcon} onClick={() => {submitRef.current.click();}}><SaveIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button type="button" className="disabled:opacity-25" disabled={insertCopyIcon} onClick={() => addNewEmployee()}><AddIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button type="button" className="disabled:opacity-25" disabled={insertCopyIcon} onClick={() => copyEmployee()}><CopyIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button className="opacity-25"><PrintIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><VerticalLineIcon/></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button className="disabled:opacity-25" onClick={() => scrollToFirst()} disabled={scrollIcons}><BackToFirstIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button className="disabled:opacity-25" onClick={() => scrollUp()} disabled={scrollIcons}><BackIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button className="disabled:opacity-25" onClick={() => scrollDown()} disabled={scrollIcons}><ForwardIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button className="disabled:opacity-25" onClick={() => scrollToLast()} disabled={scrollIcons}><ForwardToLastIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><VerticalLineIcon/></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button type="button" onClick={() => openFavoriteDialog(t('EmployeeList.Tab.New'),"EmployeeAdd")}><FavoriteIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button onClick={() => setFastView("EmployeeAdd")}><PriceIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><VerticalLineIcon/></div>
        </div>
        
        <div className="relative flex flex-col justify-left h-[calc(100vh-177px)] overflow-y-auto overflow-x-hidden">
          <div className=" mb-2 ">
          <form onSubmit={formik.handleSubmit}>
            <div className="w-auto p-6 m-4 bg-gray-100 rounded-md shadow-md">
                <h1 className="text-3xl font-semibold text-left text-zinc-900">
                   {t('EmployeeAdd.Title')}
                </h1>
                {employeeType=="edit" && <label className="block text-md font-semibold text-gray-800">{t('Common.RecordIdLabel')}: {formik.values.id}</label>}
                <div className="mt-6">
                    <div className="md:grid grid-cols-2 gap-1 mb-2">
                      <div>
                        <label
                            htmlFor="name"
                            className="block text-md font-semibold text-gray-800"
                        >
                            {t('EmployeeAdd.Label.Name')}
                        </label>
                        <input
                            name='name'
                            type="text"
                            onChange={formik.handleChange} value={formik.values.name}
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        {formik.errors.name ? <div style={{color:'red'}}>{formik.errors.name}</div> : null}
                        </div>
                        <div>
                        <label
                            htmlFor="description"
                            className="block text-md font-semibold text-gray-800"
                        >
                            {t('EmployeeAdd.Label.Description')}
                        </label>
                        <input
                            name='description'
                            type="text"
                            onChange={formik.handleChange} value={formik.values.description}
                            className="block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        {formik.errors.description ? <div style={{color:'red'}}>{formik.errors.description}</div> : null}
                        </div>
                    </div>
                    <div className="md:grid grid-cols-2 gap-4 mb-2">
                      <div>
                        <label
                            htmlFor="date_of_entry"
                            className="block text-md font-semibold text-gray-800"
                        >
                            {t('EmployeeAdd.Label.DateOfEntry')}
                        </label>
                        <input
                            name='date_of_entry'
                            type="date"
                            onChange={formik.handleChange} value={formik.values.date_of_entry}
                            className="block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                        <div>
                        <label
                            htmlFor="date_of_departure"
                            className="block text-md font-semibold text-gray-800"
                        >
                            {t('EmployeeAdd.Label.DateOfDeparture')}
                        </label>
                        <input
                            name='date_of_departure'
                            type="date"
                            onChange={formik.handleChange} value={formik.values.date_of_departure}
                            className="block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                    </div>
                    <div className="md:grid grid-cols-2 gap-4 mb-2">
                        <div>
                        <label
                            htmlFor="defined_id"
                            className="block text-md font-semibold text-gray-800"
                        >
                            {t('EmployeeAdd.Label.DefinedId')}
                        </label>
                        <input
                            name='defined_id'
                            type="number"
                            onChange={formik.handleChange} value={formik.values.defined_id}
                            className="block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        {formik.errors.defined_id ? <div style={{color:'red'}}>{formik.errors.defined_id}</div> : null}
                        </div>
                        <div>
                        <label
                            htmlFor="department_id"
                            className="block text-md font-semibold text-gray-800"
                        >
                            {t('EmployeeAdd.Label.Department')}
                        </label>
                        <select 
                        name='department_id'
                        onChange={formik.handleChange} value={formik.values.department_id}
                        required
                        className='block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'>
                          <option value="">{t('EmployeeAdd.SelectDepartment')}</option>
                          {state.departments.map((department) => (
                            <option key={department.id} value={department.id}>{department.name}</option>
                          ))}
                        </select>
                        {formik.errors.department_id ? <div style={{color:'red'}}>{formik.errors.department_id}</div> : null}
                        </div>
                    </div>
                    <div className="md:grid grid-cols-2 gap-4 mb-2">
                        <div>
                        <label
                            htmlFor="email"
                            className="block text-md font-semibold text-gray-800"
                        >
                            {t('EmployeeAdd.Label.Email')}
                        </label>
                        <input
                            name='email'
                            type="email"
                            onChange={formik.handleChange} value={formik.values.email}
                            className="block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        {formik.errors.email ? <div style={{color:'red'}}>{formik.errors.email}</div> : null}
                        </div>
                        <div>
                        <label
                            htmlFor="tel_number"
                            className="block text-md font-semibold text-gray-800"
                        >
                            {t('EmployeeAdd.Label.Phone')}
                        </label>
                        <input
                            name='tel_number'
                            type="tel"
                            onChange={formik.handleChange} value={formik.values.tel_number}
                            className="block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        {formik.errors.tel_number ? <div style={{color:'red'}}>{formik.errors.tel_number}</div> : null}
                        </div>
                    </div>
                </div>  
                <button type="submit" ref={submitRef} className='hidden'></button>
            </div>
            </form>  
            {employeeAccount ? ( <div className="w-auto p-6 m-4 bg-gray-100 rounded-md shadow-md">
                <h1 className="text-xl font-semibold text-left text-zinc-900">
                   {t('EmployeeAdd.Section.AssignedAccount')}
                </h1>
                <div className="mt-6 md:grid grid-cols-2 gap-4 mb-2">
                    <div>
                      <label
                            htmlFor="username"
                            className="block text-md font-semibold text-gray-800"
                        >
                            {t('EmployeeAdd.Label.AssignedUsername')}
                        </label>
                        <input
                            name='username'
                            type="text" readOnly={true}
                            value={formEmployee?.user?.username}
                            className="block bg-gray-50 w-full px-4 py-2 mt-2 mb-4 text-grey-700 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        <button type="button" className='w-full font-medium mb-2 px-4 py-2 tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600' onClick={() => confirmReset()}>{t('EmployeeAdd.Button.ResetPassword')}</button>
                        <button type="button" className='w-full font-medium mb-2 px-4 py-2 tracking-wide text-white transition-colors duration-200 transform bg-rose-900 rounded-md hover:bg-rose-700 focus:outline-none focus:bg-rose-600' onClick={() => confirmDelete() }>{t('EmployeeAdd.Button.DeleteAccount')}</button>
                        {/*<button className='w-full font-medium px-4 py-2 tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600'>RESETOVANIE HESLA</button>*/}                     
                    </div>
                    <div>
                      <label
                            htmlFor="role"
                            className="block text-md font-semibold text-gray-800"
                        >
                            {t('EmployeeAdd.Label.AssignedRole')}
                        </label>
                        <input
                            name='role'
                            type="text" readOnly={true}
                            value={formEmployee?.user?.role}
                            className="block bg-gray-50 w-full px-4 py-2 mt-2 mb-4 text-grey-700 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        <label
                            htmlFor="preferred_language"
                            className="block text-md font-semibold text-gray-800"
                        >
                            {t('EmployeeAdd.Label.PreferredLanguage')}
                        </label>
                        <select
                            name="preferred_language"
                            value={accountPreferredLanguage}
                            onChange={(e) => setAccountPreferredLanguage(e.target.value)}
                            className='block w-full px-4 py-2 mt-2 mb-4 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'
                        >
                            <option value="sk">Slovensky (SK)</option>
                            <option value="en">English (EN)</option>
                            <option value="de">Deutsch (DE)</option>
                        </select>
                        <button
                            type="button"
                            className='w-full font-medium mb-2 px-4 py-2 tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600 disabled:opacity-50'
                            disabled={!user?.permissions?.includes('edit users')}
                            onClick={saveAssignedUserLanguage}
                        >
                            {t('EmployeeAdd.Button.SavePreferredLanguage')}
                        </button>
                       </div>
                    <div>
                        
                    </div>   
                </div>  
            </div>):(<div className="w-auto p-6 m-4 bg-gray-100 rounded-md shadow-md">
                <form onSubmit={userformik.handleSubmit}>
                <h1 className="text-xl font-semibold text-left text-zinc-900">
                   {t('EmployeeAdd.Section.SendInvitation')}
                </h1>
                <div className="mt-6 md:grid grid-cols-2 gap-4 mb-2">
                    <div>
                      <label
                            htmlFor="username"
                            className="block text-md font-semibold text-gray-800"
                        >
                            {t('EmployeeAdd.Label.Username')}
                        </label>
                        <input
                            name='username'
                            type="text"
                            onChange={userformik.handleChange} value={userformik.values.username}
                            className="block w-full px-4 py-2 mt-2 mb-4 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        {userformik.errors.username ? <div style={{color:'red'}}>{userformik.errors.username}</div> : null}
                      <button type="submit" className='w-full font-medium px-4 py-2 mb-4 tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600'>{t('EmployeeAdd.Button.SendInvitation')}</button>
                        </div>
                        <div>
                        <label
                            htmlFor="role"
                            className="block text-md font-semibold text-gray-800"
                        >
                            {t('EmployeeAdd.Label.UserRole')}
                        </label>
                        <select 
                        name='role'
                        onChange={userformik.handleChange} value={userformik.values.role}
                        className='block w-full px-4 py-2 mt-2 mb-4 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'>
                          <option value="">{t('EmployeeAdd.SelectRole')}</option>
                          {state.roles.map((role) => (
                            <option key={role.id} value={role.name}>{role.name}</option>
                          ))}
                        </select>
                        {userformik.errors.role ? <div style={{color:'red'}}>{userformik.errors.role}</div> : null}
                        <label
                            htmlFor="preferred_language"
                            className="block text-md font-semibold text-gray-800"
                        >
                            {t('EmployeeAdd.Label.PreferredLanguage')}
                        </label>
                        <select
                            name='preferred_language'
                            onChange={userformik.handleChange}
                            value={userformik.values.preferred_language}
                            className='block w-full px-4 py-2 mt-2 mb-4 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'
                        >
                            <option value="sk">Slovensky (SK)</option>
                            <option value="en">English (EN)</option>
                            <option value="de">Deutsch (DE)</option>
                        </select>
                        </div>   
                </div>    
                </form>       
            </div>)}
            </div>
            <div>
            <input
                name='type'
                type="hidden"
                value={formik.values.type}
            />
            {/*<button type="submit" className='w-full px-4 py-2 tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600'>{t('TaskTemplateList.MaskSave')}</button>*/}
            </div>
        </div>
        </div>
    );
}